module.exports = __webpack_public_path__ + "img/pr-5.2460c4af.png";